import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '@Env/environment';
import {HelperIndividuService} from "app/archivage/common/services/helper-individu/helper-individu.service";
import {SubSink} from '@Common/core/utils/subsink';


@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit, OnDestroy {
  environment = environment;
  isGestionnaire = false;
  subSink = new SubSink();
  constructor(private helperIndividuService: HelperIndividuService) {
  }

  ngOnInit(): void {
    // accueil arrive trop vite par rapport à l'init dans app.component
    this.subSink.sink = HelperIndividuService.initDone$
      .subscribe(() => this.isGestionnaire = this.helperIndividuService.isGestionnaire);
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
